const USER_TYPES ={
  USER_SIGNIN_START:'USER_SIGNIN_START',
  USER_SIGNIN_SUCCESS:'USER_SIGNIN_SUCCESS',
  USER_SIGNIN_FAILURE:'USER_SIGNIN_FAILURE',
  USER_LOGOUT_START:'USER_LOGOUT_START',
  USER_LOGOUT_SUCCESS:'USER_LOGOUT_SUCCESS',
  CLEAR_USER_ERROR: 'CLEAR_USER_ERROR',
  USER_ENTERED_WRONG_CREDENTIALS:'USER_ENTERED_WRONG_CREDENTIALS',
  PASSANGER_INFO_FETCHING_START: 'PASSANGER_INFO_FETCHING_START',
  PASSANGER_INFO_FETCHING_FAILURE:'PASSANGER_INFO_FETCHING_FAILURE',
  PASSANGER_INFO_FETCHING_SUCCESS: 'PASSANGER_INFO_FETCHING_SUCCESS',
  START_UPDATE: 'START_UPDATE',
  UPDATE_SUCCESSFULL: 'UPDATE_SUCCESSFULL',
  UPDATE_FAILURE: 'UPDATE_FAILURE',
  SET_FLIGHT_NO: 'SET_FLIGHT_NO' 
}

export default USER_TYPES;